import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 30px;

  @media all and (max-width: 600px) {

  }

  @media all and (max-width: 450px) {
    padding:0;
  }
`;
